<template>
  <div>
    <!-- MAIN -->
    <div class="breadcrumbs ace-save-state" id="breadcrumbs">
      <ul class="breadcrumb">
        <li>
          <i class="ace-icon fa fa-home home-icon"></i>
          <a href="#/">メインメニュー</a>
        </li>
        <li class="active">システム設定</li>
      </ul><!-- /.breadcrumb -->
    </div>
    <!-- END MAIN -->
    <div class="page-content" style="padding-top:100px">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="row">
        <div class="col-xs-12">
          <div class="tabbable">
            <ul class="nav nav-tabs padding-12 tab-color-blue background-blue" id="myTab4">
              <li v-bind:class="{'active': checkActiveTab('setting1')}">
                <a data-toggle="tab" href="#setting1" aria-expanded="true" @click="changeTabActive('setting1')">NFC読み出し位置</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting2')}">
                <a data-toggle="tab" href="#setting2" aria-expanded="false" @click="changeTabActive('setting2')">キートークン有効期間</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting3')}">
                <a data-toggle="tab" href="#setting3" aria-expanded="false" @click="changeTabActive('setting3')">スマートフォン自動承認</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting4')}">
                <a data-toggle="tab" href="#setting4" aria-expanded="false" @click="changeTabActive('setting4')">照合ログ種別</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting5')}">
                <a data-toggle="tab" href="#setting5" aria-expanded="false" @click="changeTabActive('setting5')">外部ログインサービス利用設定</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="alert alert-success" v-if="message_success">
                {{ message_success }}
              </div>
              <div class="alert alert-danger" v-if="message_error">
                {{ message_error }}
              </div>
              <div id="setting1" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting1')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>システム設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="code">
                      <div class="profile-info-row">
                        <div style="width:150px"><b>NFCカード動作設定</b></div>
                        <div class="profile-info-value">
                          <select class="form-control" data-placeholder="製品名選択" v-model="settingInfor.pCodeConfigType">
                            <option v-for="item in listNfcSetting1" v-bind:value="item.type" v-bind:key="item.type">
                              {{item.name}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="possition">
                      <div><b>読み取り位置</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 1 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition1" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength1" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 2 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition2" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength2" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 3 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition3" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength3" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 1 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition1" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength1" :disabled="getEditStatus()" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 2 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition2" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength2" :disabled="getEditStatus()" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 3 位置</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition3" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength3" :disabled="getEditStatus()"  min="0" max="20">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="code">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>固定コード有効・無効</b></div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.isOwnerCodeValid"  :disabled="editStatusException">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="code">
                      <div class="profile-info-row">
                        <div style="width:150px"><b>固定コード</b></div>
                        <div class="profile-info-value" style="width:450px;border:0px solid">
                          <input type="text" class="form-control input-sm" v-model="settingInfor.ownerCode" :disabled="getEditStatus()">
                        </div>
                      </div>
                    </div>
                    <div class="felica">
                      <div><b>Felica認証情報</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">システムコード</div>
                          <div class="profile-info-value">
                            <input type="text" class="form-control input-sm" v-model="settingInfor.systemCode" :disabled="checkIsMifare()">
                          </div>
                          <div class="sub-title">サービスコード</div>
                          <div class="profile-info-value">
                            <input type="text" class="form-control input-sm" v-model="settingInfor.serviceCode" :disabled="checkIsMifare()">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">ブロックカウント</div>
                          <div class="profile-info-value">
                            <input type="number" min="0" class="form-control input-sm" v-model="settingInfor.blockCount" :disabled="checkIsMifare()">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mifare">
                      <div><b>MIFARE認証情報</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">キー種別</div>
                          <div class="profile-info-value">
                            <div style="display:inline-block;width:80px">
                              <input type="radio" name="key" value="1" v-model="settingInfor.keyType" :disabled="checkIsFalica()"/>
                              <label>Aキー</label>
                            </div>
                            <div style="display:inline-block;width:80px">
                              <input type="radio" name="key" value="0" v-model="settingInfor.keyType" :disabled="checkIsFalica()"/>
                              <label>Bキー</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">キー情報</div>
                          <div class="profile-info-value" style="width:450px">
                            <input type="text" class="form-control input-sm" v-model="settingInfor.keyValue" :disabled="checkIsFalica()">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">セクタ No</div>
                          <div class="profile-info-value">
                            <input type="text" class="form-control input-sm" v-model="settingInfor.sectorNumber" :disabled="checkIsFalica()">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="saveNfcSetting()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting2" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting2')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div>
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">オフラインでの鍵有効期間</div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.keyTokenRefreshable">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">オフラインでの鍵有効期間</div>
                        <div class="profile-info-value">
                          <select class="form-control" v-model="settingInfor.keyTokenLifetime">
                            <option v-for="item in listKeyTokenLifetime" v-bind:value="item.value" v-bind:key="item.value">
                              {{item.text}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:10px">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">更新間隔</div>
                        <div class="profile-info-value">
                          <select class="form-control" v-model="settingInfor.keyTokenRefreshRate">
                            <option v-for="item in listKeyTokenRefreshRate" v-bind:value="item.value" v-bind:key="item.value">
                              {{item.text}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="saveKeyToken()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting3" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting3')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div style="margin-bottom:15px">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">スマートフォン自動承認機能</div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.phonesBeValid">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="savePhoneStatus()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting4" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting4')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
                      {{ errorMessageLogs }}
                    </div>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listConfifLog!=null">
                      <thead>
                        <tr>
                          <th class="center">照合ログID</th>
                          <th>ログ名称</th>
                          <th class="center" style="width:110px">アクション</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in listConfifLog" :key="index">
                        <tr>
                          <td class="center accessLogId">{{item.accessLogId}}</td>
                          <td class="logLabel">{{item.logLabel}}</td>
                          <td class="center" style="width:110px">
                            <button class="btn btn-xs btn-info" @click="handleEdit(item.accessLogId)">編集</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
                      <thead>
                        <tr>
                          <th>照合ログID</th>
                          <th>ログ名称</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="3">該当するデーターがありません。</td></tr>
                      </tbody>
                    </table>
                    <div class="row" v-if="pages>0">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <paginate
                            :page-count="pages"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChange"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting5" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting5')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>システム設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <button class="btn btn-info btn-prev" id ='go-setting' @click="goPageSetting('setting')" type="button" style='display:none'>戻る</button>
                <div class="row" >
                  <div class="page-content" v-if = "isExternalLogin === 'setting'">
                    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
                    <div class="row">
                      <div class="col-xs-12" >
                        <div class="alert alert-danger" v-if="errorMessageLogs!==''">
                          {{ errorMessageLogs }}
                        </div>
                        <div class="alert alert-success" v-if="successMessageLogs!==''">
                          {{ successMessageLogs }}
                        </div>
                        <!-- PAGE CONTENT BEGINS -->
                        <div class="col-xs-12" >
                            <div class="clearfix">
                              <div class="profile-info-row">
                                <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>SAML でログイン</b></div>
                                <div class="profile-info-value">
                                    <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="isSamlFederatedLoginService === 'false'" v-model="oneloginLoginService.isValid" type="checkbox">
                                    <span class="lbl"></span>
                                    <button class="btn btn-info btn-add" :disabled ="!oneloginLoginService.isResponse || (isSamlFederatedLoginService === 'false')" @click="goRelation(oneloginLoginService)" type="button">{{lableButtonLogin.oneLogin}}</button>
                                </div>
                              </div>
                            </div>
                            <div class="">
                              <div class="profile-info-row">
                                <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px">メタデータURL</div>
                                <div class="profile-info-value" style="width:450px;border:0px solid">
                                  <input type="text" class="form-control input-sm" :disabled ="!isOneloginLoginService || (isSamlFederatedLoginService === 'false')" v-model="oneloginLoginService.metadataUrl" placeholder="メタデータURL">
                                </div>
                              </div>
                            </div>
                            <div class="clearfix" style="margin-bottom: 10px;">
                              <div class="profile-info-row">
                                <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>Google でログイン</b></div>
                                <div class="profile-info-value">
                                    <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="isFederatedLoginService === 'false'" v-model="googleLoginService.isValid" type="checkbox">
                                    <span class="lbl"></span>
                                    <button class="btn btn-info btn-add" :disabled ="!googleLoginService.isResponse || (isFederatedLoginService === 'false')" @click="goRelation(googleLoginService)" type="button">{{lableButtonLogin.googleLogin}}</button>
                                </div>
                              </div>
                            </div>
                            <div class="clearfix" style="margin-bottom: 10px;">
                              <div class="profile-info-row">
                                <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>AppleID でログイン</b></div>
                                <div class="profile-info-value">
                                    <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="isFederatedLoginService === 'false'" v-model="appleIdLoginService.isValid" type="checkbox">
                                    <span class="lbl"></span>
                                    <button class="btn btn-info btn-add" :disabled ="!appleIdLoginService.isResponse || (isFederatedLoginService === 'false')" @click="goRelation(appleIdLoginService)" type="button">{{lableButtonLogin.appleLogin}}</button>
                                </div>
                              </div>
                            </div>
                            <div class="clearfix">
                              <div class="profile-info-row">
                                <button class="btn btn-info" :disabled="!allowSubmit" type="button" @click="saveConfig()">設定を保存</button>
                              </div>
                            </div>
                        </div>
                        <!-- PAGE CONTENT ENDS -->
                      </div><!-- /.span -->
                    </div>
                  </div>
                  <div class="page-content" v-else-if = "isExternalLogin === 'registration'">
                    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
                    <div class="row">
                      <div class="col-xs-12">
                        <button class="btn btn-info btn-prev" @click="goPage('setting')" type="button">戻る</button>

                        <button v-if="cognitoIdProviderName === 'SAML'" class="btn btn-info btn-prev" :disabled ="isSamlFederatedLoginService === 'false'" style="float:right" @click="goPage('excel',cognitoIdProviderName)" type="button"> CSV一括登録 </button>
                        <button v-else class="btn btn-info btn-prev" :disabled ="isFederatedLoginService === 'false'" style="float:right" @click="goPage('excel',cognitoIdProviderName)" type="button"> CSV一括登録 </button>
                        <div class="clearfix"></div>
                        <h3 v-if="cognitoIdProviderName === 'SAML'">
                          {{lableButtonLogin.oneLogin}}
                        </h3>
                        <h3 v-else-if="cognitoIdProviderName === 'Google'">
                          {{lableButtonLogin.googleLogin}}
                        </h3>
                        <h3 v-else-if="cognitoIdProviderName === 'Apple'">
                          {{lableButtonLogin.appleLogin}}
                        </h3>
                        <h3 v-else></h3>
                        <div class="clearfix"></div>
                        <div class="alert alert-danger" v-if="error">
                          {{ message }}
                        </div>
                        <div class="alert alert-success" v-if="sucessStatus">
                          {{ message }}
                        </div>
                        <span class="input-icon search-box">
                          <input type="text" placeholder="" class="nav-search-input" id="nav-search-input" autocomplete="off" v-on:keyup.enter="searchExternalLogin()">
                          <i class="ace-icon fa fa-search nav-search-icon"></i>
                        </span>
                        <button class="btn-cusstom green-btn" type="button" @click="searchExternalLogin()">検索</button>
                        <div class="clearfix" style="clear:both; margin-bottom:10px"></div>
                        <!-- PAGE CONTENT BEGINS -->
                          <table id="relation-table" class="table  table-bordered table-hover dataTable">
                            <thead>
                              <tr>
                                <th style="width: 30%;">{{cognitoIdProviderName}}ログインID</th>
                                <th style="width: 30%;">ALLIGATEユーザーID</th>
                                <th style="width: 15%"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style="width: 30%;">
                                  <input type="text" id="new-email" v-model="newEmail" class="form-control input-sm">
                                </td>
                                <td style="width: 30%;">
                                  <div>
                                    <multiselect
                                      :allow-empty="false"
                                      v-model="newUser"
                                      id="newUser"
                                      :options="userList"
                                      placeholder=""
                                      :maxHeight="140"
                                      label="userId"
                                      :custom-label="customLabel"
                                      :show-labels="false"
                                      track-by="userId"
                                      :disabled="isDisabled"
                                      tag-placeholder="ゲートグループの追加">
                                      <span slot="noResult" style="color:red">ALLIGATEユーザーIDが見つかりません。</span>
                                      <template slot="option" slot-scope="props">
                                        <div class="option__desc"><span class="option__small">{{ props.option.userId }}</span></div>
                                      </template>
                                      </multiselect>
                                  </div>
                                </td>
                                <td class="center" style="width: 15%">
                                  <button v-if="cognitoIdProviderName === 'SAML'" @click="addRelation()" style="padding: 5px 28px;" class="btn-cusstom green-btn" :disabled ="isSamlFederatedLoginService === 'false'"><i class="fa fa-plus"></i>  登録</button>
                                  <button v-else @click="addRelation()" style="padding: 5px 28px;" class="btn-cusstom green-btn" :disabled ="isFederatedLoginService === 'false'"><i class="fa fa-plus"></i>  登録</button>
                                </td>
                              </tr>
                              <tr v-for="(item, index) in realtionsUserList" :key="index">
                                <td>
                                  <span v-if="!relationIdRowEditing[item.relationId]">{{item.federatedLoginEmail}}</span>
                                </td>
                                <td>
                                    <span v-if="!relationIdRowEditing[item.relationId]" >{{item.userId}}</span>
                                </td>
                                <td class="center" v-if="cognitoIdProviderName === 'SAML'">
                                  <button  @click="openConfirmModal(item.relationId)" v-if="!relationIdRowEditing[item.relationId]" class="btn-cusstom black-btn" :disabled ="isSamlFederatedLoginService === 'false'">削除</button>
                                </td>
                                <td class="center" v-else>
                                  <button  @click="openConfirmModal(item.relationId)" v-if="!relationIdRowEditing[item.relationId]" class="btn-cusstom black-btn" :disabled ="isFederatedLoginService === 'false'">削除</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="row" v-if="pages > 0">
                              <div class="col-xs-12">
                                <div class="dataTables_paginate paging_simple_numbers">
                                  <paginate
                                    :page-count="pages"
                                    :page-range="3"
                                    :margin-pages="2"
                                    :click-handler="handleCurrentChangeEx"
                                    :prev-text="'<<'"
                                    :next-text="'>>'"
                                    :container-class="'pagination'"
                                    :page-class="'page-item'">
                                  </paginate>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="pages === 1" style="margin-bottom:55px">
                            &nbsp;
                          </div>
                          <div id="question" class="modal fade" tabindex="-1">
                            <div class="modal-dialog">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                  <h3 class="smaller lighter frofile-title no-margin">ログインユーザーを削除</h3>
                                </div>
                                <div class="modal-body">
                                  <span class="progress-question"> ログインユーザーを削除しますか？</span>
                                </div>
                                <div class="modal-footer">
                                  <button id="yes-choice" class="btn btn-sm btn-danger pull-right" data-dismiss="modal" @click="yesChoice()" style="width: 100px;">削除</button>
                                </div>
                              </div><!-- /.modal-content -->
                            </div><!-- /.modal-dialog -->
                          </div>
                          <!-- PAGE CONTENT ENDS -->
                      </div><!-- /.row -->
                  </div><!-- /.page-content -->
                  <div class="page-content register_user" v-else-if = "isExternalLogin === 'excel'">
                    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
                    <button class="btn btn-info btn-prev"  @click="goPage('registration',cognitoIdProviderName)" type="button">戻る</button>
                    <div class="clearfix"></div>
                    <h3>{{cognitoIdProviderName}} ログインユーザー 一括登録</h3>
                    <div class="clearfix"></div>
                    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
                    <div class="tab-content">
                      <div class="row">
                        <div class="col-xs-12">
                          <!-- PAGE CONTENT BEGINS -->
                          <div class="alert alert-info">
                            {{cognitoIdProviderName}} ログインユーザーの登録を一括で実施することができます。<br />
                            登録するために必要なテンプレートCSVファイルは、”テンプレートのダウンロード”から取得してください。<br />
                            このアップロードでは、既に登録されているユーザー情報を変更することはできません。<br />
                            変更したいユーザーについては、削除を行ってから実施してください。
                          </div>
                          <div>
                            <div class="fallback">
                              <p class="desc">自分のコンピューターからファイルを選択する ：</p>
                              <label for="file_csv" class="btn-upload">
                                CSVファイルを選択
                                <input v-if="cognitoIdProviderName === 'SAML'" :disabled ="isSamlFederatedLoginService === 'false'" type="file" id="file_csv" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.csv'>
                                <input v-else :disabled ="isFederatedLoginService === 'false'" type="file" id="file_csv" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.csv'>
                              </label>
                              <span class="filename">選択されていません</span>
                              <span class="error"></span>
                              <div id="result">
                              </div>
                              <button v-if="cognitoIdProviderName === 'SAML'" :disabled ="isSamlFederatedLoginService === 'false'" class="btn btn-info" type="button" @click="importExe" data-toggle="modal">
                                登録データのアップロード
                              </button>
                              <button v-else :disabled ="isFederatedLoginService === 'false'" class="btn btn-info" type="button" @click="importExe" data-toggle="modal">
                                登録データのアップロード
                              </button>
                            </div>
                          </div>
                        </div><!-- /.col -->
                      </div><!-- /.row -->
                    </div>
                    <div class="tab-content">
                      <div class="row">
                        <div class="col-xs-12">
                          <!-- PAGE CONTENT BEGINS -->
                          <div class="alert alert-info">
                            {{cognitoIdProviderName}} ログインユーザーの登録を一括で実施するテンプレートファイルをダウンロードできます。
                          </div>
                          <div>
                            <div class="fallback">
                              <button v-if="cognitoIdProviderName === 'SAML'" class="btn btn-info" :disabled ="isSamlFederatedLoginService === 'false'" type="button" @click="getDataForExport(1)" data-toggle="modal">
                                テンプレートのダウンロード
                              </button>
                              <button v-else class="btn btn-info" :disabled ="isFederatedLoginService === 'false'" type="button" @click="getDataForExport(1)" data-toggle="modal">
                                テンプレートのダウンロード
                              </button>
                            </div>
                          </div>
                        </div><!-- /.col -->
                      </div><!-- /.row -->
                    </div>
                  </div><!-- /.page-content -->
                  <!-- プロフィールModal -->
                  <div id="process" class="modal fade" tabindex="-1">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-body">
                          <span class="progress-question">CSVファイルのアップロード</span>
                          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="message.length === 0">
                            <div class="progress-bar" :style="progressWidth">
                            <span>{{ Math.round(progress) }}%</span>
                            </div>
                          </div>
                          <div v-else style="width:100%;padding:10px;border:1px solid #ccc;color:red;margin-top:10px">
                            <div v-html="message"></div>
                          </div>
                          <span class="success-label" v-if="successItem>0">{{totalDataRow}}件中{{successItem}}件をインポートしました。</span>
                          <div v-if="errorMessageExcel.length>0">
                            <span class="error-box-title">インポート失敗</span>
                            <div class="error-box">
                              <template v-for="item in errorMessageExcel">
                                <p v-html="item" :key="item"></p>
                              </template>
                            </div>
                          </div>
                          <div class="success-label" v-if="message.length === 0 && errorMessageExcel.length === 0 && Math.round(progress) === 100 && successItem === 0">
                            {{totalDataRow}}件中{{totalDataRow}}件をインポートしました。
                          </div>
                        </div>
                        <div class="modal-footer">
                        <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success" @click="reset()">OK</button>
                        </div>
                      </div><!-- /.modal-content -->
                    </div><!-- /.modal-dialog -->
                  </div>
                </div><!-- /.row -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import multiselect from 'vue-multiselect'
import saveAs from 'file-saver/dist/FileSaver'
import router from '../../router'
export default {
  components: { multiselect },
  data () {
    return {
      lableButtonLogin: {
        oneLogin: 'SAML ログインユーザー登録',
        googleLogin: 'Google ログインユーザー登録',
        appleLogin: 'AppleID ログインユーザー登録'
      },
      listConfifLog: null,
      errorMessageLogs: '',
      successMessageLogs: '',
      pages: 0,
      selected: 100,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      listKeyTokenLifetime: [
        { text: '1時間', value: 60 },
        { text: '3時間', value: 180 },
        { text: '6時間', value: 360 },
        { text: '12時間', value: 720 },
        { text: '1日', value: 1440 },
        { text: '3日', value: 4320 },
        { text: '5日', value: 7200 },
        { text: '10日', value: 14400 },
        { text: '30日', value: 43200 }
      ],
      listKeyTokenRefreshRate: [
        { text: '30分', value: 30 },
        { text: '60分', value: 60 },
        { text: '90分', value: 90 },
        { text: '120分', value: 120 },
        { text: '150分', value: 150 },
        { text: '180分', value: 180 }
      ],
      settingInfor: {
        type: 0,
        isOwnerCodeValid: true,
        pCodeConfigType: 0,
        ownerCodePosition1: 0,
        ownerCodePosition2: 0,
        ownerCodePosition3: 0,
        ownerCodeLength1: 0,
        ownerCodeLength2: 0,
        ownerCodeLength3: 0,
        readPosition1: 0,
        readPosition2: 0,
        readPosition3: 0,
        readLength1: 0,
        readLength2: 0,
        readLength3: 0,
        systemCode: '',
        serviceCode: '',
        blockCount: 0,
        keyType: 0,
        keyValue: '',
        sectorNumber: 0,
        ownerCode: '',
        phonesBeValid: false,
        keyTokenRefreshable: false,
        keyTokenLifetime: 60,
        keyTokenRefreshRate: 30
      },
      scorp: ['accessLogId', 'logLabel'],
      editStatus: true,
      editStatusException: true,
      listNfcSetting: null,
      listNfcSetting1: [],
      loading: false,
      isFelica: true,
      isMifare: true,
      flag: true,
      message_error: '',
      message_success: '',
      fistTime: true,
      // 外部ログインサービス利用設定
      error: '',
      errorMessage: '',
      sucessSttatus: '',
      initFinish: false,
      federatedLoginServices: [],
      googleLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        isValid: false,
        name: 'Google',
        oldIsValid: false,
        isSaml: false,
        isResponse: false
      },
      oneloginLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        oldMetadataUrl: '',
        isValid: false,
        name: 'SAML',
        oldIsValid: false,
        isSaml: false,
        isResponse: false
      },
      appleIdLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        isValid: false,
        name: 'Apple',
        oldIsValid: false,
        isSaml: false,
        isResponse: false
      },
      savingProgress: 0,
      allowSubmit: false,
      isFederatedLoginService: 'false',
      isSamlFederatedLoginService: 'false',
      isExternalLogin: '',
      // ログインユーザー登録
      message: '',
      sucessStatus: '',
      userList: [],
      updateUserid: '',
      updateEmail: '',
      newUser: '',
      newEmail: '',
      deleteRelationId: '',
      pageSizeList: 25,
      isDisabled: true,
      realtionsUserList: [],
      relationIdRowEditing: {},
      loginServiceType: '',
      OwnerFederatedLoginService: [],
      cognitoIdProviderName: '',
      federatedLoginServiceId: '',
      currPage: 1,
      relationOwnerFederatedLoginServiceId: '',
      // ログインユーザー一括登録
      files: null,
      errorMessageExcel: [],
      importData: [],
      errorName: '',
      progress: 0,
      success: false,
      totalDataRow: 0,
      exeCount: 0,
      successItem: 0,
      percent: 0,
      isSendEmail: false,
      pagesRelation: 0,
      isVisible: false,
      exportData: [],
      dataLoad: 0,
      percentExport: 0,
      isSaveGoogle: true,
      isSaveOnelogin: true,
      isSaveAppleId: true,
      isOneloginLoginService: false
    }
  },
  created () {
    this.getFederatedLoginService()
    var p = this.$route.query.p
    if (p !== '' && p !== undefined && p !== null) {
      localStorage.setItem('isExternalLogin', p)
    } else {
      localStorage.setItem('isExternalLogin', 'setting')
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    }
  },
  watch: {
    'settingInfor.pCodeConfigType': 'checkEditStatus',
    savingProgress: function (newVal, oldVal) {
      if (newVal === 3) {
        this.getOwnerFederatedLoginService()
        // set message
        // this.message
        this.savingProgress = 0
        this.loading = false
        var listLogin = ''
        this.successMessageLogs = ''
        this.errorMessageLogs = ''
        if (this.isSaveOnelogin === true && this.isSaveGoogle === true && this.isSaveAppleId === true) {
          this.successMessageLogs = '外部ログインサービスの設定を保存しました。'
        } else if (this.isSaveOnelogin === false && this.isSaveGoogle === false && this.isSaveAppleId === false) {
          this.errorMessageLogs = '外部ログインサービスの設定の保存に失敗しました。'
        } else {
          if (this.isSaveOnelogin === false) {
            listLogin += Config.ONELOGIN + ','
          }
          if (this.isSaveGoogle === false) {
            listLogin += Config.GOOGLE + ','
          }
          if (this.isSaveAppleId === false) {
            listLogin += Config.APPLEID + ','
          }
          this.errorMessageLogs = listLogin.replace(/,+$/, '') + 'の設定の保存に失敗しました。再度設定変更の保存を実施してください。'
        }
      }
    },
    'googleLoginService.isValid': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    },
    'oneloginLoginService.isValid': function (newVal, oldVal) {
      this.isOneloginLoginService = newVal
      this.allowSubmit = this.checkIsChangeConfig()
    },
    'appleIdLoginService.isValid': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    },
    'oneloginLoginService.metadataUrl': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    },
    // ログインユーザー一括登録
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        vm.addExe(vm.importData[newVal][0], vm.importData[newVal][1], vm.importData[newVal][2], (newVal + 2), vm.percent)
      } else if (newVal > 0 && newVal === vm.totalDataRow) {
        this.exeCount = 0
        this.success = true
        this.importData = []
      }
    },
    dataLoad: function (newVal, oldVal) {
      if (newVal > 0 && newVal === this.pages) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForExport(newVal + 1)
      }
    }
  },
  mounted () {
    var vm = this
    // 外部ログインサービス利用設定
    vm.isExternalLogin = localStorage.isExternalLogin
    vm.cognitoIdProviderName = localStorage.cognitoIdProviderName
    vm.federatedLoginServiceId = localStorage.federatedLoginServiceId
    if (vm.isExternalLogin === 'setting') {
      this.getPlan()
        .then(() => {
          vm.isFederatedLoginService = localStorage.isFederatedLoginService
          vm.isSamlFederatedLoginService = localStorage.isSamlFederatedLoginService
          this.loading = false
        })
    } else if (vm.isExternalLogin === 'registration') {
      this.getUsers(1)
      this.getPlan()
        .then(() => this.getOwnerFederatedLoginService())
        .then(() => this.getFederatedLoginRelation())
        .then(() => {
          vm.isFederatedLoginService = localStorage.isFederatedLoginService
          vm.isSamlFederatedLoginService = localStorage.isSamlFederatedLoginService
          this.loading = false
        })
    } else {
      this.getPlan()
        .then(() => this.getOwnerFederatedLoginService())
        .then(() => {
          vm.isFederatedLoginService = localStorage.isFederatedLoginService
          vm.isSamlFederatedLoginService = localStorage.isSamlFederatedLoginService
          this.loading = false
          var ID = vm.getFederatedLoginServiceRelationId(vm.federatedLoginServiceId)
          vm.relationOwnerFederatedLoginServiceId = ID
        })
    }
    // Setting
    vm.getTypeInfo()
    vm.getOwnerInfor()
    vm.getListConfigLog()
    // $('#nav-search-input').keyup(function (e) {
    //   if (e.keyCode === 13) {
    //     vm.search()
    //   }
    // })
    if (typeof localStorage.pageSizeLogConfig === 'undefined') {
      localStorage.setItem('pageSizeLogConfig', 100)
      this.selected = localStorage.pageSizeLogConfig
    } else {
      this.selected = localStorage.pageSizeLogConfig
    }
    if (typeof localStorage.configLogSortKey === 'undefined') {
      localStorage.setItem('configLogSortKey', 'accessLogId')
    }
    if (typeof localStorage.configLogSortName === 'undefined') {
      localStorage.setItem('configLogSortName', 'desc')
    }
    if (typeof localStorage.activeTab === 'undefined') {
      localStorage.setItem('activeTab', 'setting1')
    }
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.searchExternalLogin()
      }
    })
  },
  methods: {
    getEditStatus () {
      if (this.settingInfor.isOwnerCodeValid && (this.editStatusException === false)) {
        return false
      } else {
        return true
      }
    },
    checkIsFalica () {
      var vm = this
      if (vm.isFelica) {
        return true
      } else {
        return false
      }
    },
    checkIsMifare () {
      var vm = this
      if (vm.isMifare) {
        return true
      } else {
        return false
      }
    },
    checkActiveTab (activeTab) {
      if (localStorage.activeTab === activeTab) {
        return true
      } else {
        return false
      }
    },
    changeTabActive (tabName) {
      this.pages = 0
      this.resetMessage()
      this.resetInput()
      this.message_success = ''
      this.message_error = ''
      localStorage.setItem('activeTab', tabName)
    },
    handleEdit (id) {
      this.$router.push({name: 'configLogEdit', query: { id: id }})
    },
    // 検索項目チェンジ(操作ログ)
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    getListConfigLog () {
      this.$http.get(Config.CONFIG_LOG_API + '?limit=' + localStorage.pageSizeLogConfig + '&page=' + this.listQuery.currPage + '&sortKey=' + localStorage.configLogSortName + ':' + localStorage.configLogSortKey)
        .then(response => {
          console.log(response)
          this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogConfig)
          this.listConfifLog = response.body.logConfigs
          console.log(response)
        })
        .catch((error) => {
          this.listConfifLog = null
          this.loading = false
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = '照合ログマスターの取得権限がありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeLogConfig', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.getListConfigLog()
    },
    handleCurrentChange (val) {
      this.listQuery.currPage = val
      this.getListConfigLog()
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('configLogSortName', 'desc')
        localStorage.setItem('configLogSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('configLogSortName', 'asc')
        localStorage.setItem('configLogSortKey', sortkey)
      }
      this.search()
    },
    search () {
      console.log('search function')
    },
    saveKeyToken () {
      this.message_success = ''
      this.message_error = ''
      var vm = this
      if (vm.settingInfor.keyTokenRefreshRate >= vm.settingInfor.keyTokenLifetime) {
        this.message_error = '更新間隔は、有効期間より長く設定することはできません。'
      } else {
        vm.loading = true
        const Infor = {
          keyTokenRefreshable: vm.settingInfor.keyTokenRefreshable,
          keyTokenLifetime: vm.settingInfor.keyTokenLifetime,
          keyTokenRefreshRate: vm.settingInfor.keyTokenRefreshRate
        }
        console.log(Infor)
        this.$http.put(Config.OWNER_API + '/' + localStorage.ownerId, Infor)
          .then(response => {
            console.log(response)
            this.loading = false
            this.message_success = Config.EDIT_SETTING_API_SUCCESS
            this.message_error = ''
          })
          .catch((error) => {
            this.message_success = ''
            if (error.body) {
              this.loading = false
              this.message_error = Config.ADD_API_ERROR
            } else {
              this.loading = false
              this.message_error = Config.SERVER_CONNECT_ERROR
            }
          })
      }
    },
    savePhoneStatus () {
      var vm = this
      vm.loading = true
      this.message_success = ''
      this.message_error = ''
      const Infor = {
        phonesBeValid: vm.settingInfor.phonesBeValid
      }
      console.log(Infor)
      this.$http.put(Config.OWNER_API + '/' + localStorage.ownerId, Infor)
        .then(response => {
          console.log(response)
          this.loading = false
          this.message_success = Config.EDIT_SETTING_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.message_success = ''
          if (error.body) {
            this.loading = false
            this.message_error = Config.ADD_API_ERROR
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    validateBeforeSubmit () {
      this.flag = 0
      var isOk = /^[0-9A-F]+$/.test(this.settingInfor.gatePasswordSeed)
      if (!isOk || this.gateInfor.gatePasswordSeed.length > 18 || this.gateInfor.gatePasswordSeed.length < 18) {
        $('#passwordseed_error').html('半角英数（0～9、A〜F）で18文字入力してください。')
        $('#pseed').addClass('error')
        this.flag += 1
      } else {
        $('#passwordseed_error').html('')
        $('#pseed').removeClass('error')
        this.flag = 0
      }
      if (this.flag === 0) {
        this.saveNfcSetting()
      }
    },
    saveNfcSetting () {
      var vm = this
      vm.loading = true
      this.message_success = ''
      this.message_error = ''
      var Infor = {
        pCodeConfigType: vm.settingInfor.pCodeConfigType
      }
      switch (vm.settingInfor.pCodeConfigType) {
        case 0: // 製造番号読み出し
          break
        case 1:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          }
          break
        case 2:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          }
          break
        case 3:
          break
        case 4:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              blockCount: parseInt(vm.settingInfor.blockCount),
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              type: 0,
              credential: {
                felica: {
                  systemCode: vm.settingInfor.systemCode,
                  serviceCode: vm.settingInfor.serviceCode
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              blockCount: parseInt(vm.settingInfor.blockCount),
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              type: 0,
              credential: {
                felica: {
                  systemCode: vm.settingInfor.systemCode,
                  serviceCode: vm.settingInfor.serviceCode
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          }
          break
        case 5:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              sectorNumber: parseInt(vm.settingInfor.sectorNumber),
              type: 1,
              credential: {
                mifare: {
                  keyType: parseInt(vm.settingInfor.keyType),
                  keyValue: vm.settingInfor.keyValue
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              sectorNumber: parseInt(vm.settingInfor.sectorNumber),
              type: 1,
              credential: {
                mifare: {
                  keyType: parseInt(vm.settingInfor.keyType),
                  keyValue: vm.settingInfor.keyValue
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          }
          break
        case 6: // 製造番号読み出し（Felica）
          break
        case 7: // 製造番号読み出し（MYFARE）
          break
      }
      console.log(Infor)
      this.$http.put(Config.OWNER_API + '/' + encodeURIComponent(localStorage.ownerId), Infor)
        .then(response => {
          this.loading = false
          this.message_success = Config.EDIT_SETTING_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.message_success = ''
          if (error.body) {
            this.loading = false
            this.message_error = Config.ADD_API_ERROR
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    checkEditStatus () {
      var vm = this
      if (!vm.fistTime) {
        vm.settingInfor.ownerCodePosition1 = 0
        vm.settingInfor.ownerCodePosition2 = 0
        vm.settingInfor.ownerCodePosition3 = 0
        vm.settingInfor.ownerCodeLength1 = 0
        vm.settingInfor.ownerCodeLength2 = 0
        vm.settingInfor.ownerCodeLength3 = 0
        vm.settingInfor.readPosition1 = 0
        vm.settingInfor.readPosition2 = 0
        vm.settingInfor.readPosition3 = 0
        vm.settingInfor.readLength1 = 0
        vm.settingInfor.readLength2 = 0
        vm.settingInfor.readLength3 = 0
        vm.settingInfor.ownerCode = ''
        vm.settingInfor.systemCode = ''
        vm.settingInfor.serviceCode = ''
        vm.settingInfor.blockCount = 0
        vm.settingInfor.keyType = 1
        vm.settingInfor.keyValue = ''
        vm.settingInfor.sectorNumber = ''
        vm.settingInfor.isOwnerCodeValid = false
      }
      switch (vm.settingInfor.pCodeConfigType) {
        case 0: // 製造番号読み出し
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
        case 1:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = false
          break
        case 2:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = false
          break
        case 3:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
        case 4:
          vm.fistTime = false
          vm.editStatus = false
          vm.isFelica = true
          vm.isMifare = false
          vm.editStatusException = false
          break
        case 5:
          vm.fistTime = false
          vm.editStatus = false
          vm.isFelica = false
          vm.isMifare = true
          vm.editStatusException = false
          break
        case 6: // 製造番号読み出し（Felica）
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
        case 7: // 製造番号読み出し（MYFARE）
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
      }
    },
    // NFC読み取り設定種別取得
    getTypeInfo () {
      var vm = this
      this.$http.get(Config.CONFIG_PCODE_TYPE_API)
        .then(response => {
          vm.listNfcSetting = response.body.pCodeConfigTypes
          if (vm.listNfcSetting.length > 0) {
            // task 22404: require list (0, 6, 7, 1, 2, 3, 4, 5)
            var index = 1
            vm.listNfcSetting.forEach(function (item) {
              if (item.type === 6 || item.type === 7) {
                // if type = 6, 7 then push into list by index
                vm.listNfcSetting1.splice(index, 0, item) // 0: not remove any item
                index++
              } else {
                vm.listNfcSetting1.push(item)
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    getOwnerInfor () {
      var vm = this
      this.$http.get(Config.OWNER_API + '?ownerId=' + encodeURIComponent(localStorage.ownerId))
        .then(response => {
          console.log(response)
          vm.fistTime = true
          vm.settingInfor.pCodeConfigType = response.body.owners[0].pCodeConfigType
          vm.settingInfor.phonesBeValid = response.body.owners[0].phonesBeValid
          vm.settingInfor.keyTokenRefreshable = response.body.owners[0].keyTokenRefreshable
          vm.settingInfor.keyTokenLifetime = response.body.owners[0].keyTokenLifetime
          vm.settingInfor.keyTokenRefreshRate = response.body.owners[0].keyTokenRefreshRate
          vm.settingInfor.type = response.body.owners[0].pCodeConfig.type
          vm.settingInfor.isOwnerCodeValid = response.body.owners[0].pCodeConfig.isOwnerCodeValid
          vm.settingInfor.ownerCode = response.body.owners[0].pCodeConfig.ownerCode
          if (!vm.isEmpty(response.body.owners[0].pCodeConfig)) {
            var ownerCodePosition = response.body.owners[0].pCodeConfig.ownerCodePosition
            for (var i = 0; i < ownerCodePosition.length; i++) {
              switch (i) {
                case 0:
                  vm.settingInfor.ownerCodePosition1 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength1 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
                case 1:
                  vm.settingInfor.ownerCodePosition2 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength2 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
                case 2:
                  vm.settingInfor.ownerCodePosition3 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength3 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
              }
            }
            var readPosition = response.body.owners[0].pCodeConfig.readPosition
            for (var j = 0; j < readPosition.length; j++) {
              switch (j) {
                case 0:
                  vm.settingInfor.readPosition1 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength1 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
                case 1:
                  vm.settingInfor.readPosition2 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength2 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
                case 2:
                  vm.settingInfor.readPosition3 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength3 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
              }
            }
            if (vm.settingInfor.type === 0) {
              console.log(response.body.owners[0].pCodeConfig)
              if (!vm.isEmpty(response.body.owners[0].pCodeConfig.credential)) {
                vm.settingInfor.systemCode = response.body.owners[0].pCodeConfig.credential.felica.systemCode
                vm.settingInfor.serviceCode = response.body.owners[0].pCodeConfig.credential.felica.serviceCode
              }
              vm.settingInfor.blockCount = response.body.owners[0].pCodeConfig.blockCount
            } else {
              vm.settingInfor.keyType = response.body.owners[0].pCodeConfig.credential.mifare.keyType
              vm.settingInfor.keyValue = response.body.owners[0].pCodeConfig.credential.mifare.keyValue
              vm.settingInfor.sectorNumber = response.body.owners[0].pCodeConfig.sectorNumber
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 外部ログインサービス利用設定
    checkIsChangeConfig () {
      if (this.googleLoginService.oldIsValid !== this.googleLoginService.isValid) {
        return true
      }
      if (this.oneloginLoginService.oldIsValid !== this.oneloginLoginService.isValid || this.oneloginLoginService.oldMetadataUrl !== this.oneloginLoginService.metadataUrl) {
        return true
      }
      if (this.appleIdLoginService.oldIsValid !== this.appleIdLoginService.isValid) {
        return true
      }
      return false
    },
    getFederatedLoginService () {
      this.loading = true
      this.$http.get(Config.FEDERATED_LOGIN_SERVICE_API)
        .then((response) => {
          this.federatedLoginServices = response.body.federatedLoginServices
          this.getFederatedLoginServiceId('Onelogin')
          this.getFederatedLoginServiceId('Google')
          this.getFederatedLoginServiceId('Apple')
          this.getOwnerFederatedLoginService()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getFederatedLoginServiceId (providerName) {
      switch (providerName) {
        case 'Google':
          var googleId = this.federatedLoginServices.filter(element => element.name === 'Google')
          if (googleId.length > 0) {
            this.googleLoginService.federatedLoginServiceId = googleId[0].federatedLoginServiceId
            this.googleLoginService.name = googleId[0].name
          }
          break
        case 'Onelogin':
          var oneloginId = this.federatedLoginServices.filter(element => element.name === 'Onelogin')
          if (oneloginId.length > 0) {
            this.oneloginLoginService.federatedLoginServiceId = oneloginId[0].federatedLoginServiceId
            // this.oneloginLoginService.name = oneloginId[0].name
            this.oneloginLoginService.name = 'SAML'
          }
          break
        case 'Apple':
          var appleId = this.federatedLoginServices.filter(element => element.name === 'Apple')
          if (appleId.length > 0) {
            this.appleIdLoginService.federatedLoginServiceId = appleId[0].federatedLoginServiceId
            this.appleIdLoginService.name = appleId[0].name
          }
          break
        default:
          break
      }
    },
    getOwnerFederatedLoginService () {
      return new Promise((resolve, reject) => {
        this.$http.get(Config.OWNER_FEDERATED_LOGIN_SERVICE_API + '?embed=federatedLoginService')
          .then((response) => {
            this.OwnerFederatedLoginService = response.body.relationsOwnerFederatedLoginService
            this.isLoginServiceEnable()
            resolve()
          })
          .catch((err) => {
            console.log(err)
            resolve()
          })
      })
    },
    saveConfig () {
      this.loading = true
      this.isSaveGoogle = true
      this.isSaveOnelogin = true
      this.isSaveAppleId = true
      this.saveOnelogin()
      this.saveGoogle()
      this.saveAppleId()
    },
    saveOnelogin () {
      if (this.oneloginLoginService.oldIsValid !== this.oneloginLoginService.isValid || this.oneloginLoginService.oldMetadataUrl !== this.oneloginLoginService.metadataUrl) {
        this.isSaveOnelogin = false
        if (this.oneloginLoginService.relationId === '') {
          this.submitRelationConfig(Config.ONELOGIN, this.oneloginLoginService.federatedLoginServiceId, this.oneloginLoginService.isValid, this.oneloginLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(Config.ONELOGIN, this.oneloginLoginService.relationId, this.oneloginLoginService.isValid, this.oneloginLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },
    saveGoogle () {
      if (this.googleLoginService.oldIsValid !== this.googleLoginService.isValid) {
        this.isSaveGoogle = false
        if (this.googleLoginService.relationId === '') {
          this.submitRelationConfig(Config.GOOGLE, this.googleLoginService.federatedLoginServiceId, this.googleLoginService.isValid, this.googleLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(Config.GOOGLE, this.googleLoginService.relationId, this.googleLoginService.isValid, this.googleLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },
    saveAppleId () {
      if (this.appleIdLoginService.oldIsValid !== this.appleIdLoginService.isValid) {
        this.isSaveAppleId = false
        if (this.appleIdLoginService.relationId === '') {
          this.submitRelationConfig(Config.APPLEID, this.appleIdLoginService.federatedLoginServiceId, this.appleIdLoginService.isValid, this.appleIdLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(Config.APPLEID, this.appleIdLoginService.relationId, this.appleIdLoginService.isValid, this.appleIdLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },

    submitRelationConfig (type, federatedLoginServiceId, isValid, metadataUrl) {
      var data = ''
      if (isValid === true) {
        data = {
          federatedLoginServiceId: federatedLoginServiceId,
          isValid: isValid,
          metadataFile: '',
          metadataUrl: metadataUrl
        }
      } else {
        data = {
          federatedLoginServiceId: federatedLoginServiceId,
          isValid: isValid,
          metadataFile: ''
        }
      }
      this.$http.post(Config.OWNER_FEDERATED_LOGIN_SERVICE_API, data)
        .then((response) => {
          console.log(response.status)
          this.savingProgress++
          this.checkSaveStatus(type)
        }).catch((error) => {
          console.log(error)
          this.savingProgress++
        })
    },
    updateRelationConfig (type, relationId, isValid, metadataUrl) {
      var data = ''
      if (isValid === true) {
        data = {
          metadataUrl: metadataUrl,
          metadataFile: '',
          isValid: isValid
        }
      } else {
        data = {
          metadataFile: '',
          isValid: isValid
        }
      }
      this.$http.put(Config.OWNER_FEDERATED_LOGIN_SERVICE_API + '/' + relationId, data)
        .then((response) => {
          console.log(response.status)
          this.savingProgress++
          this.checkSaveStatus(type)
        }).catch((error) => {
          console.log(error)
          this.savingProgress++
        })
    },
    isLoginServiceEnable () {
      var gg = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.googleLoginService.federatedLoginServiceId)
      var ol = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.oneloginLoginService.federatedLoginServiceId)
      var ap = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.appleIdLoginService.federatedLoginServiceId)
      if (gg.length > 0) {
        this.googleLoginService.isValid = gg[0].isValid
        this.googleLoginService.oldIsValid = gg[0].isValid
        this.googleLoginService.relationId = gg[0].relationId
        this.googleLoginService.isSaml = gg[0].federatedLoginService.isSaml
        this.googleLoginService.isResponse = true
      }
      if (ol.length > 0) {
        this.oneloginLoginService.isValid = ol[0].isValid
        this.oneloginLoginService.oldIsValid = ol[0].isValid
        this.oneloginLoginService.relationId = ol[0].relationId
        this.oneloginLoginService.metadataUrl = ol[0].metadataUrl
        this.oneloginLoginService.oldMetadataUrl = ol[0].metadataUrl
        this.oneloginLoginService.isSaml = ol[0].federatedLoginService.isSaml
        this.oneloginLoginService.isResponse = true
      }
      if (ap.length > 0) {
        this.appleIdLoginService.isValid = ap[0].isValid
        this.appleIdLoginService.oldIsValid = ap[0].isValid
        this.appleIdLoginService.relationId = ap[0].relationId
        this.appleIdLoginService.isSaml = ap[0].federatedLoginService.isSaml
        this.appleIdLoginService.isResponse = true
      }
    },
    // ログインユーザー登録
    editRelationIdRow (relationIdRow, updateEmail, updateUserid) {
      this.relationIdRowEditing = []
      this.updateEmail = updateEmail
      this.updateUserid = {userId: updateUserid}
      this.relationIdRowEditing[relationIdRow] = true
    },
    getUsers (page) {
      this.$http.get(Config.USERS_LIST_API + '?limit=1000&page=' + page + '&sortKey=asc:userId&isValid=true&exclude=thumbnail')
        .then(response => {
          if (response.body.maxRecords > 0) {
            response.body.users.forEach(element => {
              this.userList.push({userId: element.userId})
            })
            if (response.body.maxRecords > response.body.endRecord) {
              this.getUsers(page + 1)
            } else {
              this.isDisabled = false
            }
          } else {
            this.userList = null
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFederatedLoginRelation () {
      return new Promise((resolve, reject) => {
        var ID = this.getFederatedLoginServiceRelationId(this.federatedLoginServiceId)
        this.realtionsUserList = []
        if (ID) {
          var keyword = $('.nav-search-input').val()
          if (keyword !== undefined) {
            keyword = keyword.replace(/\s/g, ',')
            keyword = encodeURIComponent(keyword)
          }
          var apiLink = Config.USER_FEDERATED_LOGIN_SERVICE_API + '?limit=' + this.pageSizeList + '&page=' + this.currPage + '&relationOwnerFederatedLoginServiceId=' + ID
          if (keyword !== '' && keyword !== undefined) {
            apiLink = Config.USER_FEDERATED_LOGIN_SERVICE_API + '?limit=' + this.pageSizeList + '&page=' + this.currPage + '&relationOwnerFederatedLoginServiceId=' + ID + '&keyword=' + keyword
          }
          this.relationOwnerFederatedLoginServiceId = ID
          this.$http.get(apiLink)
            .then(response => {
              if (response.body.maxRecords > 0) {
                response.body.relationsUserFederatedLoginService.forEach(element => {
                  this.realtionsUserList.push(element)
                })
                this.pages = Math.ceil((response.body.maxRecords) / this.pageSizeList)
              } else {
                this.realtionsUserList = []
              }
              this.loading = false
              resolve()
            })
            .catch((error) => {
              this.realtionsUserList = []
              resolve()
              console.log(error)
            })
        } else {
          resolve()
        }
      })
    },
    getFederatedLoginServiceProviderName (relationsOwnerFederatedLoginServiceId) {
      const relation = this.OwnerFederatedLoginService.filter(element => element.relationId === relationsOwnerFederatedLoginServiceId)
      if (relation.length > 0) {
        return relation[0].cognitoIdProviderName
      }
    },
    getFederatedLoginServiceRelationId (federatedLoginServiceId) {
      const relation = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === federatedLoginServiceId)
      if (relation.length > 0) {
        return relation[0].relationId
      } else {
        return false
      }
    },
    handleCurrentChangeEx (val) {
      this.resetMessage()
      this.resetInput()
      this.loading = true
      this.currPage = val
      this.getFederatedLoginRelation()
      window.scrollTo(0, 0)
    },
    addRelation () {
      var canSubmit = this.validateBeforeSubmitEx()
      var Infor = {
        userId: this.newUser.userId,
        federatedLoginEmail: this.newEmail,
        relationOwnerFederatedLoginServiceId: this.relationOwnerFederatedLoginServiceId
      }
      if (canSubmit) {
        this.loading = true
        this.$http.post(Config.USER_FEDERATED_LOGIN_SERVICE_API, Infor)
          .then(response => {
            console.log(response)
            this.realtionsUserList = []
            this.pages = 0
            this.currPage = 1
            this.getFederatedLoginRelation()
            this.resetInput()
            this.message = 'ログインユーザーが追加されました。'
            this.sucessStatus = true
            this.loading = false
          })
          .catch((error) => {
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.message = ''
                } else {
                  this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 500:
                this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
            this.error = true
            // this.getFederatedLoginRelation()
            // this.realtionsUserList = []
            // this.currPage = 1
            this.loading = false
            this.sucessStatus = false
          })
      }
    },
    deleteRelation () {
      this.loading = true
      this.$http.delete(Config.USER_FEDERATED_LOGIN_SERVICE_API + '/' + this.deleteRelationId)
        .then(response => {
          console.log(response)
          this.realtionsUserList = []
          this.pages = 0
          this.currPage = 1
          this.getFederatedLoginRelation()
          this.resetInput()
          this.message = 'ログインユーザーが削除されました。'
          this.loading = false
          this.error = false
          this.sucessStatus = true
        })
        .catch((error) => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.message = ''
              } else {
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 500:
              this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          this.error = true
          this.sucessStatus = false
          this.loading = false
        })
    },
    customLabel (user) {
      if (user.userId.length > 50) {
        return user.userId.substring(0, 49) + '...'
      }
      return user.userId
    },
    validateBeforeSubmitEx () {
      this.error = false
      this.message = ''
      this.sucessStatus = false
      var validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/.test(this.newEmail)
      if (!validEmail) {
        this.error = true
        $('#new-email').addClass('error')
        this.message = '正しい' + this.cognitoIdProviderName + 'ログインIDを入力してください。'
        return false
      } else {
        $('#new-email').removeClass('error')
      }
      var userID = 0
      if (this.newUser !== '' && this.newUser.userId !== null && this.newUser.userId !== '' && this.newUser.userId !== undefined) {
        userID = this.newUser.userId
      }
      var validUserID = /^[a-zA-Z0-9@.!#$%&'*+/=?^_`{|}~-]{4,96}$/.test(userID)
      if (!validUserID) {
        $('.multiselect').addClass('error')
        this.message = 'ALLIGATEユーザーIDは必須です。'
        this.error = true
        return false
      } else {
        $('.multiselect').removeClass('error')
      }
      return true
    },
    yesChoice () {
      // Delete
      this.deleteRelation()
    },
    openConfirmModal (relationId) {
      this.deleteRelationId = relationId
      $('#question').modal({
        backdrop: 'static'
      })
    },
    goRelation (loginService) {
      this.pages = 0
      this.currPage = 1
      router.push({ query: Object.assign({}, this.$route.query, { p: 'registration' }) })
      this.resetMessage()
      this.resetInput()
      localStorage.setItem('isExternalLogin', 'registration')
      localStorage.setItem('cognitoIdProviderName', loginService.name)
      localStorage.setItem('federatedLoginServiceId', loginService.federatedLoginServiceId)
      this.cognitoIdProviderName = localStorage.cognitoIdProviderName
      this.isExternalLogin = localStorage.isExternalLogin
      this.federatedLoginServiceId = localStorage.federatedLoginServiceId
      // ログインユーザー登録
      this.userList = []
      this.realtionsUserList = []
      this.loading = true
      return this.getPlan()
        .then(() => this.getUsers(1))
        .then(() => this.getOwnerFederatedLoginService())
        .then(() => this.getFederatedLoginRelation())
        .then(() => {
          this.isFederatedLoginService = localStorage.isFederatedLoginService
          this.loading = false
        })
    },
    searchExternalLogin () {
      this.pages = 0
      this.currPage = 1
      this.resetMessage()
      this.resetInput()
      this.cognitoIdProviderName = localStorage.cognitoIdProviderName
      this.isExternalLogin = localStorage.isExternalLogin
      this.federatedLoginServiceId = localStorage.federatedLoginServiceId
      // ログインユーザー登録
      this.userList = []
      this.realtionsUserList = []
      this.getUsers(1)
      this.loading = true
      return this.getOwnerFederatedLoginService()
        .then(() => this.getFederatedLoginRelation())
        .then(() => {
          this.loading = false
        })
    },
    goPageSetting (page, cognitoIdProviderName = '') {
      this.resetMessage()
      this.resetInput()
      localStorage.setItem('cognitoIdProviderName', cognitoIdProviderName)
      localStorage.setItem('isExternalLogin', page)
      this.isExternalLogin = localStorage.isExternalLogin
      if (page === 'setting') {
        // let query = Object.assign({}, this.$route.query)
        // delete query.p
        // router.replace({ query })
        this.loading = true
        return this.getPlan()
          .then(() => this.getOwnerFederatedLoginService())
          .then(() => {
            this.isFederatedLoginService = localStorage.isFederatedLoginService
            this.loading = false
          })
      }
    },
    goPage (page, cognitoIdProviderName = '') {
      this.resetMessage()
      this.resetInput()
      this.pages = 0
      localStorage.setItem('cognitoIdProviderName', cognitoIdProviderName)
      localStorage.setItem('isExternalLogin', page)
      this.isExternalLogin = localStorage.isExternalLogin
      if (page === 'setting') {
        let query = Object.assign({}, this.$route.query)
        delete query.p
        router.replace({ query })
        this.loading = true
        return this.getPlan()
          .then(() => this.getOwnerFederatedLoginService())
          .then(() => {
            this.isFederatedLoginService = localStorage.isFederatedLoginService
            this.loading = false
          })
      } else if (page === 'registration') {
        var loginService = this.googleLoginService
        if (cognitoIdProviderName === Config.APPLEID) {
          loginService = this.appleIdLoginService
        } else if (cognitoIdProviderName === Config.ONELOGIN) {
          loginService = this.oneloginLoginService
        }
        this.goRelation(loginService)
      } else {
        router.push({ query: Object.assign({}, this.$route.query, { p: page }) })
        if (page === 'excel') {
          this.dataLoad = 0
          this.cognitoIdProviderName = localStorage.cognitoIdProviderName
          this.getPlan()
            .then(() => {
              this.isFederatedLoginService = localStorage.isFederatedLoginService
              this.loading = false
            })
          this.getPages()
        }
      }
    },
    // ログインユーザー一括登録
    reset () {
      this.exportData = []
      this.importData = []
      this.exeCount = 0
      this.successItem = 0
      setTimeout(() => {
        this.success = false
      }, 200)
      this.loading = false
      this.errorName = ''
      this.progress = 0
      this.files = null
      this.pages = 0
      this.dataLoad = 0
      $('.filename').html('選択されていません')
      $('#file_csv').val('')
      this.message = ''
      this.errorMessageExcel = []
      $('#process').modal('hide')
    },
    resetInput () {
      this.newUser = []
      this.newEmail = null
      $('#new-email').removeClass('error')
      $('.multiselect').removeClass('error')
    },
    resetMessage () {
      this.sucessStatus = false
      this.error = false
      this.errorMessageLogs = ''
      this.successMessageLogs = ''
    },
    previewFiles () {
      this.files = this.$refs.myFiles.files[0]
      $('.filename').html(this.files.name)
    },
    replaceSpecilSymboy (txtString) {
      return txtString.replace(/\r/g, '').replace(/\n/g, '\r\n')
    },
    addExe (email, userId, change, z, percent) {
      var vm = this
      change = vm.replaceSpecilSymboy(change)
      const Infor = {
        userId: vm.replaceSpecilSymboy(userId),
        federatedLoginEmail: vm.replaceSpecilSymboy(email),
        relationOwnerFederatedLoginServiceId: this.relationOwnerFederatedLoginServiceId
      }
      if (change === '1') {
        this.$http.post(Config.USER_FEDERATED_LOGIN_SERVICE_API, Infor)
          .then(response => {
            console.log(response.status)
            setTimeout(function () {
              vm.exeCount++
              vm.progress += percent
              vm.successItem++
            }, 200)
          })
          .catch((error) => {
            var rowstatus = ''
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  vm.errorName = ''
                } else {
                  vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 403:
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 409:
                vm.errorName = '入力されたユーザーIDは既に使用されています。ユーザーIDをご確認ください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 500:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 503:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              default:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
            }
            this.$set(this.errorMessageExcel, z, rowstatus)
            setTimeout(function () {
              vm.exeCount++
              vm.progress += percent
            }, 200)
            console.log(error.status)
          })
      } else if (change === '2') {
        this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API + '?relationOwnerFederatedLoginServiceId=' + this.relationOwnerFederatedLoginServiceId + '&userId=' + vm.replaceSpecilSymboy(userId))
          .then(response => {
            var relationId = ''
            response.body.relationsUserFederatedLoginService.forEach(function (item) {
              relationId = item.relationId
            })
            if (relationId !== '') {
              this.$http.delete(Config.USER_FEDERATED_LOGIN_SERVICE_API + '/' + relationId)
                .then(response => {
                  setTimeout(function () {
                    vm.exeCount++
                    vm.progress += percent
                    vm.successItem++
                    console.log(response.status)
                  }, 200)
                })
                .catch((error) => {
                  var rowstatus = ''
                  switch (error.status) {
                    case 401:
                      if (error.body.message === 'The incoming token has expired') {
                        vm.errorName = ''
                      } else {
                        vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                      }
                      break
                    case 400:
                      vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                    case 403:
                      vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                    case 409:
                      vm.errorName = '入力されたユーザーIDは既に使用されています。ユーザーIDをご確認ください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                    case 500:
                      vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                    case 503:
                      vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                    default:
                      vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                      rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                      break
                  }
                  this.$set(this.errorMessageExcel, z, rowstatus)
                  setTimeout(function () {
                    vm.exeCount++
                    vm.progress += percent
                    console.log(error.status)
                  }, 200)
                })
            }
          })
          .catch((error) => {
            var rowstatus = ''
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  vm.errorName = ''
                } else {
                  vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 403:
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 409:
                vm.errorName = '入力されたユーザーIDは既に使用されています。ユーザーIDをご確認ください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 500:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              case 503:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
              default:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = z + ' 行目>>' + userId + '(' + email + ') >><span>' + vm.errorName + '</span>'
                break
            }
            this.$set(this.errorMessageExcel, z, rowstatus)
            setTimeout(function () {
              vm.exeCount++
              vm.progress += percent
              console.log(error.status)
            }, 200)
          })
      } else {
        setTimeout(function () {
          vm.exeCount++
          vm.progress += percent
          vm.successItem++
        }, 200)
      }
    },
    getPages () {
      var vm = this
      this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API)
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.pages = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentExport = (100 / (vm.pages))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    downloadCSV () {
      var vm = this
      var filename
      var csv = this.convertArrayOfObjectsToCSV({
        data: vm.exportData
      })
      filename = 'user-federated-login-data.csv'
      if (this.cognitoIdProviderName !== '') {
        filename = this.cognitoIdProviderName.toLowerCase() + '-user-federated-login-data.csv'
      }
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var blob = new Blob([ bom, csv ], {type: 'text/csv;charset=utf-8;'})
      // ダウンロード実行
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        saveAs(blob, filename)
      } else {
        if (window.navigator.msSaveOrOpenBlob) {
          // IEの場合
          navigator.msSaveBlob(blob, filename)
        } else {
          // IE以外(Chrome, Firefox)
          var downloadLink = $('<a></a>')
          downloadLink.attr('href', window.URL.createObjectURL(blob))
          downloadLink.attr('download', filename)
          downloadLink.attr('target', '_blank')
          $('body').append(downloadLink)
          downloadLink[0].click()
          downloadLink.remove()
        }
      }
    },
    convertArrayOfObjectsToCSV (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data
      data = args.data || null
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      return result
    },
    getDataForExport (page) {
      var vm = this
      var ID = this.getFederatedLoginServiceRelationId(vm.federatedLoginServiceId)
      var lable = vm.cognitoIdProviderName + 'ID'
      if (ID) {
        this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API + '?limit=1000&page=' + page + '&relationOwnerFederatedLoginServiceId=' + ID)
          .then(response => {
            response.body.relationsUserFederatedLoginService.forEach(function (item) {
              vm.exportData.push({
                [lable]: item.federatedLoginEmail,
                'ALLIGATEユーザーID': item.userId,
                '変更（1：登録、2：削除、3：変更無し）': 3
              })
            })
            vm.progress += vm.percentExport
            vm.pages = Math.ceil((response.body.maxRecords) / 1000)
            vm.dataLoad++
          })
          .catch((error) => {
            vm.progress += vm.percentExport
            vm.exportData = []
            vm.exportData.push({
              [lable]: '',
              'ALLIGATEユーザーID': '',
              '変更（1：登録、2：削除、3：変更無し）': ''
            })
            this.isVisible = false
            this.downloadCSV()
            this.reset()
            console.log(error)
          })
      } else {
        vm.exportData = []
        vm.exportData.push({
          [lable]: '',
          'ALLIGATEユーザーID': '',
          '変更（1：登録、2：削除、3：変更無し）': ''
        })
        this.downloadCSV()
        this.reset()
      }
    },
    importExe () {
      var vm = this
      $('#process').modal({
        backdrop: 'static'
      })
      if (this.files !== null) {
        this.progress = 0
        this.errorMessageExcel = []
        var reader = new FileReader()
        reader.onload = function () {
          var lineArr = reader.result.split('\n')
          var itemArr = []
          for (var i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split(',')
          }
          var checkLable = vm.cognitoIdProviderName + 'ID'
          if (itemArr.length > 1) {
            if (itemArr[0][0] === undefined || itemArr[0][0] !== checkLable) {
              vm.success = true
              vm.message = '選択されたファイルフォーマットが外部ログインサービスの種類と異なります。 選択ファイルを確認して下さい。'
            } else {
              vm.importData = []
              for (var k = 1; k < itemArr.length; k++) {
                if (itemArr[k].length === 3 && itemArr[k][0].length > 0) {
                  vm.importData.push(itemArr[k])
                }
              }
              if (vm.importData.length > 0) {
                vm.totalDataRow = vm.importData.length
                vm.message = ''
                vm.percent = (100 / (vm.totalDataRow))
                vm.addExe(vm.importData[0][0], vm.importData[0][1], vm.importData[0][2], 2, vm.percent)
              } else {
                vm.success = true
                vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
              }
            }
          } else {
            vm.success = true
            vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
          }
        }
        reader.onerror = function () {
          vm.success = true
          vm.message = '選択されているファイルの読み込みに失敗しました。<br>ブラウザの更新、もしくは別ファイルを選択してから <br> 再度アップロードしたいファイルを選択してください。'
        }
        reader.readAsText(this.files, 'Shift_JIS')
      } else {
        vm.success = true
        vm.message = 'CSVのファイルを選択してください。'
      }
    },
    checkSaveStatus (type) {
      switch (type) {
        case Config.GOOGLE :
          this.isSaveGoogle = true
          break
        case Config.ONELOGIN :
          this.isSaveOnelogin = true
          break
        case Config.APPLEID :
          this.isSaveAppleId = true
          break
      }
    },
    getPlan () {
      return new Promise((resolve, reject) => {
        this.pages = 0
        this.loading = true
        localStorage.setItem('isMfa', false)
        localStorage.setItem('isFederatedLoginService', false)
        localStorage.setItem('isSamlFederatedLoginService', false)
        this.$http.get(Config.PLAN_API)
          .then((response) => {
            if (response.body.maxRecords > 0) {
              localStorage.setItem('isMfa', response.body.plans[0].isMfa)
              localStorage.setItem('isFederatedLoginService', response.body.plans[0].isFederatedLoginService)
              localStorage.setItem('isSamlFederatedLoginService', response.body.plans[0].isSamlFederatedLoginService)
            }
            resolve()
          }).catch((error) => {
            console.log(error)
            resolve()
          })
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
input[type=checkbox].ace.ace-switch+.lbl::before{
  text-indent: 25px!important;
  content: "無効"!important;
}
input[type=checkbox].ace.ace-switch:checked+.lbl::before{
  text-indent: 5px!important;
  content: "有効"!important;
}
input[type=number]{
  width: 160px
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
  vertical-align: text-top;
}
.mifare, .possition, .felica, .code, .nfc{
  margin-bottom: 10px
}
.main-title {
  width: 150px
}
.possition .sub-title {
  width: 50px;
  text-align: center;
}
.felica .sub-title,.mifare .sub-title{
  width: 115px;
  text-align: center;
}
.bootstrap-timepicker-widget table td input {
  width: 35px;
}
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.btn-add {
  display: inline-block;
  vertical-align: top;
  margin-top: -3px;
  margin-left: 10px;
  padding: 0px 12px;
  min-width: 240px;
  float: right;
}
.btn-prev {
  vertical-align: top;
  padding: 0px 12px;
  margin-bottom: 10px;
  float: left;
}
.profile-info-value {
  width: 450px;
}
#relation-table .multiselect__tags {
    min-height: 20px !important;
    height: 31px;
    border-radius: unset;
    padding: 5px 40px 0px 8px;
    margin-top: 0px;
}
#relation-table .multiselect__tags input{
    border: none;
    padding-top: 0px;
    height: 15px;
}
#relation-table .multiselect__select:before {
    top: 62%;
}
#relation-table .multiselect {
    min-height: 30px;
}
#relation-table>tbody>tr>td {
    vertical-align: middle;
    padding: 5px;
    font-size: 16px;
}
.invisibility {
  visibility: hidden
}
.multiselect.error , .loginServiceType.error  {
    border: 1px solid red;
}
.btn-cusstom[disabled], .btn-cusstom[disabled].active, .btn-cusstom[disabled]:active, .btn-cusstom[disabled]:focus, .btn-cusstom[disabled]:hover {
    background: #ccc !important;
    border: 5px solid #ccc !important;
    white-space: normal;
}
#setting5 .page-content {
  padding-top: 0px !important;
}
#setting5 .page-content h3{
  margin-top: 0px;
}
#result p {
  margin-bottom: 0px
}
#result span {
  display: inline-block;
  padding: 5px;
}
#result span.error {
  color: red
}
#result span.success {
  color: #87B87F;
}
#result p.block {
  display: block;
  margin-bottom: 1px;
}
.btn-upload{
  color: white;
  background-color: #000;
  padding: 6px 15px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-block;
  margin: 0px 15px
}
.desc{
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}
.filename{
  display: inline-block;
}
.hide{
  display: none;
}
.error{
  display: block;
  color: #FF4040
}
</style>



// WEBPACK FOOTER //
// src/views/setting/SettingList.vue